import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import MilkCard from './MilkCard.svelte';
import EmptyState from '../shared/EmptyState.svelte';
import { getSettings } from '../../lib/stores/settings.svelte.ts';
import { formatVolume } from '../../lib/utils/units.ts';

var root_3 = $.from_html(`<div class="fifo-nudge svelte-26bgl78m8orn8"> </div>`);
var root_4 = $.from_html(`<div class="location-group svelte-26bgl78m8orn8"><div class="group-header svelte-26bgl78m8orn8"><h3 class="svelte-26bgl78m8orn8"> </h3> <span class="group-total svelte-26bgl78m8orn8"> </span></div> <div class="group-entries svelte-26bgl78m8orn8"></div></div>`);
var root_2 = $.from_html(`<!> <!>`, 1);

function Inventory($$anchor, $$props) {
	$.push($$props, true);

	const settings = $.derived(getSettings);
	const isImperial = $.derived(() => $.get(settings).units === 'imperial');

	const locationLabels = {
		fridge: 'Fridge',
		freezer: 'Freezer',
		'deep-freezer': 'Deep Freezer'
	};

	const groups = $.derived(() => () => {
		const map = new Map();

		for (const entry of $$props.entries) {
			const list = map.get(entry.location) || [];

			list.push(entry);
			map.set(entry.location, list);
		}

		return Array.from(map.entries()).map(([location, items]) => ({
			location,
			label: locationLabels[location] || location,
			totalMl: items.reduce((sum, e) => sum + e.remainingVolumeMl, 0),
			entries: items
		}));
	});

	const oldestFridge = $.derived(() => () => {
		const fridgeEntries = $$props.entries.filter((e) => e.location === 'fridge');

		if (fridgeEntries.length === 0) return null;

		const oldest = fridgeEntries.sort((a, b) => a.storedAt - b.storedAt)[0];
		const age = Date.now() - oldest.storedAt;
		const twoDays = 2 * 24 * 60 * 60 * 1000;

		if (age > twoDays) return oldest;

		return null;
	});

	var fragment = $.comment();
	var node = $.first_child(fragment);

	{
		var consequent = ($$anchor) => {
			var fragment_1 = $.comment();
			var node_1 = $.first_child(fragment_1);

			EmptyState(node_1, {
				title: 'No milk stored',
				description: 'Stored milk from pump sessions will appear here',
				icon: '🫙'
			});

			$.append($$anchor, fragment_1);
		};

		var alternate = ($$anchor) => {
			var fragment_2 = root_2();
			var node_2 = $.first_child(fragment_2);

			{
				var consequent_1 = ($$anchor) => {
					var div = root_3();
					var text = $.child(div);

					$.reset(div);

					$.template_effect(($0) => $.set_text(text, `Oldest fridge milk first: ${$0 ?? ''}`), [
						() => new Date($.get(oldestFridge)().storedAt).toLocaleDateString([], { month: 'short', day: 'numeric' })
					]);

					$.append($$anchor, div);
				};

				var d = $.derived(() => $.get(oldestFridge)());

				$.if(node_2, ($$render) => {
					if ($.get(d)) $$render(consequent_1);
				});
			}

			var node_3 = $.sibling(node_2, 2);

			$.each(node_3, 17, () => $.get(groups)(), $.index, ($$anchor, group) => {
				var div_1 = root_4();
				var div_2 = $.child(div_1);
				var h3 = $.child(div_2);
				var text_1 = $.child(h3, true);

				$.reset(h3);

				var span = $.sibling(h3, 2);
				var text_2 = $.child(span, true);

				$.reset(span);
				$.reset(div_2);

				var div_3 = $.sibling(div_2, 2);

				$.each(div_3, 21, () => $.get(group).entries, (entry) => entry.id, ($$anchor, entry) => {
					var fragment_3 = $.comment();
					var node_4 = $.first_child(fragment_3);

					MilkCard(node_4, {
						get entry() {
							return $.get(entry);
						},

						get ondelete() {
							return $$props.onrefresh;
						}
					});

					$.append($$anchor, fragment_3);
				});

				$.reset(div_3);
				$.reset(div_1);

				$.template_effect(
					($0) => {
						$.set_text(text_1, $.get(group).label);
						$.set_text(text_2, $0);
					},
					[() => formatVolume($.get(group).totalMl, $.get(isImperial))]
				);

				$.append($$anchor, div_1);
			});

			$.append($$anchor, fragment_2);
		};

		$.if(node, ($$render) => {
			if ($$props.entries.length === 0) $$render(consequent); else $$render(alternate, -1);
		});
	}

	$.append($$anchor, fragment);
	$.pop();
}

if (import.meta.hot) {
	Inventory = $.hmr(Inventory);

	import.meta.hot.accept((module) => {
		$.cleanup_styles('svelte-26bgl78m8orn8');
		Inventory[$.HMR].update(module.default);
	});
}

export default Inventory;
import "bun-svelte:Inventory.svelte-3qa69r6uadqw1-style.css";